import { api } from "../api";

const BASE_URL = "/accounting/employee-payroll/total-salary";
const BASE_URL_V2 = "/accounting/employee-payroll";
const BASE_URL_V3 = "/accounting/employee-salary";

export const getEmployeeTotalSalary = (
  employeeType,
  startCutoffDate,
  endCutoffDate,
  date,
  search
) => {
  const params = new URLSearchParams({
    employeeType,
    startCutoffDate,
    endCutoffDate,
    date,
  });

  if (search) {
    params.append("search", search);
  }

  return api.get(`${BASE_URL}?${params.toString()}`);
};

export const getEmployeePayroll = (employeeId, durationIn, durationOut) => {
  return api.get(
    `${BASE_URL_V2}?employeeId=${employeeId}&durationIn=${durationIn}&durationOut=${durationOut}`
  );
};

export const getEmployeeSalary = () => {
  return api.get(`${BASE_URL_V3}`);
};
